import http from '../helpers/http';
import { List } from 'immutable';

export default class DataRepository {
    manualLookup(surname, initial, dob, cardNumber) {
        return http.post('/api/v1/data/lookup', {
            surname,
            initial,
            dob,
            sentinelNo: cardNumber ? cardNumber.toString().replace('-', '') : ''
        }).then(matches => {
            return List(matches).sortBy(m => m.name).toArray()
        });
    }
}